import { useEffect, useState } from "react";
import { useTranslate } from "src/locales";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import { Box, Checkbox, CardHeader, Card } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  rowsGuide,
  rowsPlan,
  rowsNursingIntervention,
  RowDataPlan,
  RowDataNursingIntervention,
} from "./rows";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridToolbar,
  GridColDef,
} from "@mui/x-data-grid";
import ByzNurseAddButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseAddButton";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import MealAdd from "../meal-add"; // RationAdd bileşeni import edildi
import DietTypeAdd from "../diet-type-add"; // Import DietTypeAdd component
import DietAdd from "../diet-add"; // Import RationAdd component
import ByzMuiRound from "src/components/core-components/mui/buttons/ByzMuiRound";
import ByzDeleteConfirmDialog from "src/components/core-components/mui/ByzDeleteConfirmDialog";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { GridCellParams } from "@mui/x-data-grid-premium"; // Add this import
// import RationProcessService from "src/api/ration-process/RationProcessService";
//OAERDOGAN;449425;10042025
type ModalState = {
  addGuide: boolean;
  addPlan: boolean;
  addNurseIntervention: boolean;
  editId: string;
};
const diet = [
  {
    id: "",
    Name: "Sabah",
    Note: "Test",
    DiabetVegan: "Test",
    Halal: "Test",
    Time: "10:00",
    Active: "",
    Edit: "",
    delete: "",
  },
];
const dietTypes = [
  {
    id: "",
    Name: "",
    companion: "",
    snack: "",
    Active: "24.12.2024",
    Edit: "24.12.2024",
    delete: "24.12.2024",
  },
];

const initialRows = [
  {
    id: "",
    Open: "",
    Office: "Yazılım Test Hastanesi",
    Name: "Sabah",
    Time: "10:00",
    Category: "Sabah",
    Active: "",
    Edit: "24.12.2024",
    delete: "24.12.2024 ",
  },
  {
    id: 2,
    Open: "",
    Office: "Yazılım Test Hastanesi",
    Name: "Öğle",
    Time: "10:00",
    Category: "Öğle",
    Active: "",
    Edit: "24.12.2024",
    delete: "24.12.2024",
  },
  {
    id: 3,
    Open: "",
    Office: "Yazılım Test Hastanesi",
    Name: "Gece",
    Time: "10:00",
    Category: "Gece",
    Active: "",
    Edit: "",
    delete: "24.12.2024",
  },
];

function Ration() {
  type DeleteType = "plans" | "guides" | "nursingInterventions";
  const theme = useTheme();
  const isTabletDown = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedRows, setSelectedRows] = useState<
    Record<string, number | null>
  >({
    guide: null,
    plan: null,
    nursingIntervention: null,
  });
  const handleCheckboxChange = (type: DeleteType, id: number) => {
    setSelectedRows((prev) => ({
      ...prev,
      [type]: prev[type] === id ? null : id,
    }));
  };
  const [rows, setRows] = useState(initialRows);
  const [modalState, setModalState] = useState<ModalState>({
    addGuide: false,
    addPlan: false,
    addNurseIntervention: false,
    editId: "",
  });
  const [dietType, setDietType] = useState(dietTypes);
  const [dietRows, setDietRows] = useState(diet);
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  const [openDietTypePopup, setOpenDietTypePopup] = useState(false);
  const [openDietPopup, setOpenDietPopup] = useState(false);
  const [deleteState, setDeleteState] = useState({
    open: false,
    rowId: "",
    url: "",
  });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenDietTypePopup = () => setOpenDietTypePopup(true);
  const handleCloseDietTypePopup = () => setOpenDietTypePopup(false);
  const handleOpenDietPopup = () => setOpenDietPopup(true);
  const handleCloseDietPopup = () => setOpenDietPopup(false);
  const handleDeleteRow = (id: string, url: string) => {
    setDeleteState({ open: true, rowId: id, url });
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          color: "#00B8D9",
          flexWrap: "wrap",
          rowGap: 1,
          columnGap: 1,
          justifyContent: "space-between",
          "& .MuiDataGrid-toolbarContainer": {
            flexWrap: "wrap",
          },
        }}
      >
        <GridToolbar />
        <GridToolbarQuickFilter
          placeholder={t("search")}
          sx={{
            ml: { xs: 0, sm: "auto" },
            width: { xs: "100%", sm: "auto" },
            minWidth: { sm: 220 },
          }}
        />
      </GridToolbarContainer>
    );
  }
  const getColumnWidth = (
    mobileWidth: number,
    tabletWidth: number,
    desktopFlex = 1
  ) =>
    isMobile
      ? { width: mobileWidth, minWidth: mobileWidth }
      : isTabletDown
      ? { width: tabletWidth, minWidth: tabletWidth }
      : { flex: desktopFlex, minWidth: tabletWidth };

  const getActionColumnWidth = (mobileWidth = 130, tabletWidth = 140) =>
    isMobile
      ? { width: mobileWidth, minWidth: mobileWidth, maxWidth: mobileWidth }
      : { width: tabletWidth, minWidth: tabletWidth, maxWidth: tabletWidth };

  const sharedGridSx = {
    "& .MuiDataGrid-columnHeader": {
      py: isMobile ? 0.5 : 0.75,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: isMobile ? "16px" : "18px",
    },
    "& .MuiDataGrid-cell": {
      fontSize: isMobile ? "12px" : "13px",
    },
    "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
      justifyContent: "center",
    },
    "& .MuiDataGrid-cell[data-field='OFFICE'], & .MuiDataGrid-cell[data-field='NAME'], & .MuiDataGrid-cell[data-field='NOTE'], & .MuiDataGrid-cell[data-field='CATEGORY'], & .MuiDataGrid-cell[data-field='GOAL'], & .MuiDataGrid-cell[data-field='AUTOMATIC_CALL_SNACK'], & .MuiDataGrid-cell[data-field='LASTTIME'], & .MuiDataGrid-cell[data-field='DIABET'], & .MuiDataGrid-cell[data-field='VEGAN'], & .MuiDataGrid-cell[data-field='HYPERTENSION'], & .MuiDataGrid-cell[data-field='HALAL']": {
      justifyContent: "flex-start",
    },
    "& .MuiDataGrid-columnHeader[data-field='OFFICE'], & .MuiDataGrid-columnHeader[data-field='NAME'], & .MuiDataGrid-columnHeader[data-field='NOTE'], & .MuiDataGrid-columnHeader[data-field='CATEGORY'], & .MuiDataGrid-columnHeader[data-field='GOAL'], & .MuiDataGrid-columnHeader[data-field='AUTOMATIC_CALL_SNACK'], & .MuiDataGrid-columnHeader[data-field='LASTTIME'], & .MuiDataGrid-columnHeader[data-field='DIABET'], & .MuiDataGrid-columnHeader[data-field='VEGAN'], & .MuiDataGrid-columnHeader[data-field='HYPERTENSION'], & .MuiDataGrid-columnHeader[data-field='HALAL']": {
      justifyContent: "flex-start",
    },
  } as const;
  const diett = [
    {
      field: "id",
      headerName: t("ration.name"),
      flex: 1,
    },
    {
      field: "Name",
      headerName: t("ration.name"),
      flex: 1,
    },
    {
      field: "Note",
      headerName: t("ration.note"),
      flex: 1,
    },
    {
      field: "DiabetVegan",
      headerName: t("ration.vegan"),
      flex: 1,
    },
    {
      field: "Halal",
      headerName: t("ration.halal"),
      flex: 1,
    },
    {
      field: "Time",
      headerName: t("ration.last-request-time"),
      flex: 1,
    },
    {
      field: "Active",
      headerName: t("active"),
      flex: 1,
    },
    {
      field: "Edit",
      headerName: t("ration.edit"),
      flex: 1,
    },
    {
      field: "delete",
      headerName: t("delete"),
      flex: 1,
      renderCell: (params: any) => (
        <>
          <ByzGrdDeleteButton
            onClick={() => handleDeleteRow(params.row.id, "some-url")}
          />
          <ByzDeleteConfirmDialog
            open={deleteState.open}
            onClose={() => setDeleteState({ ...deleteState, open: false })}
            patientId={deleteState.rowId}
            url={deleteState.url}
            onSuccess={() => console.log("success")}
            title={t("definition-delete")}
            content={t("definition-delete-content")}
          />
        </>
      ),
    },
  ];
  const diettypecolumns: GridColDef[] = [
    {
      field: "id",
      headerName: t("choose"),
      flex: 1,
      renderCell(params) {
        return (
          <ByzMuiCheckBox
            checked={params.value}
            onChange={() => console.log("Checkbox clicked")}
          />
        );
      },
    },
    {
      field: "Name",
      headerName: t("ration.name"),
      flex: 1,
    },
    {
      field: "companion",
      headerName: t("ration.companion"),
      flex: 1,
      renderCell: (params) => <ByzMuiRound />,
    },
    {
      field: "snack",
      headerName: t("ration.snack"),
      flex: 1,
    },
    {
      field: "Active",
      headerName: t("active"),
      flex: 1,
      renderCell: (params) => <ByzMuiRound />,
    },
    {
      field: "Edit",
      headerName: t("ration.edit"),
      flex: 1,
      renderCell: (params) => (
        <ByzGrdEditButton onClick={() => alert("Update Button Clicked")} />
      ),
    },
    {
      field: "delete",
      headerName: t("delete"),
      flex: 1,
      renderCell: (params) => (
        <>
          <ByzGrdDeleteButton
            onClick={() => handleDeleteRow(params.row.id, "some-url")}
          />
          <ByzDeleteConfirmDialog
            open={deleteState.open}
            onClose={() => setDeleteState({ ...deleteState, open: false })}
            patientId={deleteState.rowId}
            url={deleteState.url}
            onSuccess={() => console.log("success")}
            title={t("definition-delete")}
            content={t("definition-delete-content")}
          />
        </>
      ),
    },
  ];
  const columns: GridColDef[] = [
    {
      field: "TransactionType",
      headerName: t("choose"),
      flex: 1,
      renderCell(params) {
        return (
          <ByzMuiCheckBox
            checked={params.value}
            onChange={() => console.log("Checkbox clicked")}
          />
        );
      },
    },
    { field: "Office", headerName: t("office"), flex: 1 },
    { field: "Name", headerName: t("ration.name"), flex: 1 },
    { field: "Time", headerName: t("ration.last-request-time"), flex: 1 },
    { field: "Category", headerName: t("category"), flex: 1 },
    {
      field: "Active",
      headerName: t("active"),
      flex: 1,
      renderCell: (params) => <ByzMuiRound />,
    },
    {
      field: "Edit",
      headerName: t("ration.edit"),
      flex: 1,
      renderCell: (params) => (
        <ByzGrdEditButton
          onClick={() =>
            setModalState({
              ...modalState,
              editId: params.row?.id?.toString() || "",
            })
          }
        />
      ),
    },
    {
      field: "delete",
      headerName: t("delete"),
      flex: 1,
      renderCell: (params: any) => (
        <>
          <ByzGrdDeleteButton
            onClick={() => handleDeleteRow(params.row.id, "some-url")}
          />
          <ByzDeleteConfirmDialog
            open={deleteState.open}
            onClose={() => setDeleteState({ ...deleteState, open: false })}
            patientId={deleteState.rowId}
            url={deleteState.url}
            onSuccess={() => console.log("success")}
            title={t("definition-delete")}
            content={t("definition-delete-content")}
          />
        </>
      ),
    },
  ];
  const renderCheckbox = (checked: boolean) => <Checkbox checked={checked} />;
  const renderCheckboxChose = (type: DeleteType, id: number) => (
    <Checkbox
      checked={selectedRows[type] === id}
      onChange={() => {
        handleCheckboxChange(type, id);
      }}
    />
  );
  const createColumns = (type: any): GridColDef[] => {
    if (type === "guide") {
      return [
        {
          field: "id",
          headerName: t("choose"),
          ...getColumnWidth(90, 90),
          renderCell: (params: GridCellParams) =>
            renderCheckboxChose(type, params.id as number),
        },
        {
          field: "OFFICE",
          headerName: t("ration.office"),
          ...getColumnWidth(180, 220),
        },
        {
          field: "NAME",
          headerName: t("ration.name"),
          ...getColumnWidth(140, 160),
        },

        {
          field: "LASTTIME",
          headerName: t("ration.last-request-time"),
          ...getColumnWidth(150, 170),
        },
        {
          field: "CATEGORY",
          headerName: t("category"),
          ...getColumnWidth(130, 150),
        },
        {
          field: "IS_ACTIVE",
          headerName: t("active"),
          ...getActionColumnWidth(120, 130),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "edit",
          headerName: t("buttons.edit"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdEditButton
              onClick={() => {
                setModalState({
                  ...modalState,
                  addGuide: true,
                  addPlan: false,
                  addNurseIntervention: false,
                  editId: params.row?.id?.toString() || "",
                });
                handleOpen();
              }}
            />
          ),
        },
        {
          field: "delete",
          headerName: t("buttons.delete"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdDeleteButton
              onClick={() =>
                handleDeleteRow(params.row?.id?.toString() || "", type)
              }
            />
          ),
        },
      ];
    }
    if (type === "plan") {
      return [
        {
          field: "id",
          headerName: t("choose"),
          ...getColumnWidth(90, 90),
          renderCell: (params: GridCellParams) =>
            renderCheckboxChose(type, params.id as number),
        },
        {
          field: "NAME",
          headerName: t("ration.name"),
          ...getColumnWidth(150, 170),
        },
        {
          field: "GOAL",
          headerName: t("ration.companion"),
          ...getColumnWidth(120, 140),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "AUTOMATIC_CALL_SNACK",
          headerName: t("ration.snack"),
          ...getColumnWidth(150, 180),
        },
        {
          field: "IS_ACTIVE",
          headerName: t("active"),
          ...getActionColumnWidth(120, 130),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "edit",
          headerName: t("buttons.edit"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdEditButton
              onClick={() => {
                setModalState({
                  ...modalState,
                  addGuide: false,
                  addPlan: true,
                  addNurseIntervention: false,
                  editId: params.row?.id?.toString() || "",
                });
                handleOpenDietTypePopup(); // Open DietTypeAdd screen
              }}
            />
          ),
        },
        {
          field: "delete",
          headerName: t("buttons.delete"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdDeleteButton
              onClick={() =>
                handleDeleteRow(params.row?.id?.toString() || "", type)
              }
            />
          ),
        },
      ];
    }
    if (type === "nursingInterventions") {
      return [
        {
          field: "NAME",
          headerName: t("ration.name"),
          ...getColumnWidth(140, 160),
        },

        {
          field: "NOTE",
          headerName: t("ration.note"),
          ...getColumnWidth(150, 180),
        },
        {
          field: "DIABET",
          headerName: t("ration.diabet"),
          ...getColumnWidth(120, 140),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "VEGAN",
          headerName: t("ration.vegan"),
          ...getColumnWidth(110, 130),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "HYPERTENSION",
          headerName: t("ration.hypertension"),
          ...getColumnWidth(140, 170),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "HALAL",
          headerName: t("ration.halal"),
          ...getColumnWidth(110, 130),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "LASTTIME",
          headerName: t("ration.last-request-time"),
          ...getColumnWidth(150, 170),
        },
        {
          field: "IS_ACTIVE",
          headerName: t("active"),
          ...getActionColumnWidth(120, 130),
          renderCell: (params: GridCellParams) => <ByzMuiRound />,
        },
        {
          field: "edit",
          headerName: t("buttons.edit"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdEditButton
              onClick={() => {
                setModalState({
                  ...modalState,
                  addGuide: false,
                  addPlan: false,
                  addNurseIntervention: true,
                  editId: params.row?.id?.toString() || "",
                });
                handleOpenDietPopup(); // Open DietAdd screen
              }}
            />
          ),
        },
        {
          field: "delete",
          headerName: t("buttons.delete"),
          ...getActionColumnWidth(116, 130),
          renderCell: (params: GridCellParams) => (
            <ByzGrdDeleteButton
              onClick={() =>
                handleDeleteRow(params.row?.id?.toString() || "", type)
              }
            />
          ),
        },
      ];
    }
    return [];
  };
  const [rowsPlanDatas, setRowsPlanDatas] = useState<RowDataPlan[]>([]);
  const [rowsNursingInterventionDatas, setRowsNursingInterventionDatas] =
    useState<RowDataNursingIntervention[]>([]);
  const [selectedMealIds, setSelectedMealID] = useState<number[]>([]);

  useEffect(() => {
    console.log(selectedRows);
    if (selectedRows.guide) {
      //Apiye istek atılarak planlar çekilerek set edilecek.
      setRowsPlanDatas(rowsPlan);
    }
    if (selectedRows.plan) {
      //Apiye istek atılarak hemşirelik girişimleri çekilerek set edilecek.
      setRowsNursingInterventionDatas(rowsNursingIntervention);
    }
  }, [selectedRows]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "7px 17px",
          alignItems: "flex-end",
          alignContent: "flex-end",
        }}
      >
        {[
          {
            title: t("ration.meal"),
            columns: createColumns("guide"),
            rows: rowsGuide,
            addModalState: "addGuide",
          },
          {
            title: t("ration.diet-type"),
            columns: createColumns("plan"),
            rows: rowsPlanDatas,
            addModalState: "addPlan",
          },
          {
            title: t("ration.diet"),
            columns: createColumns("nursingInterventions"),
            rows: rowsNursingInterventionDatas,
            addModalState: "addNurseIntervention",
          },
        ].map(({ title, columns, rows, addModalState }) => (
          <Card key={title} sx={{ width: "100%" }}>
            <CardHeader title={title} />
            <Box sx={{ px: { xs: 1.5, sm: 2.5 }, pt: 1.5, pb: 1 }}>
              {(title === t("ration.meal") ||
                title === t("ration.diet-type") ||
                title === t("ration.diet")) && (
                <ByzNurseAddButton
                  onClick={
                    title === t("ration.meal")
                      ? handleOpen
                      : title === t("ration.diet-type")
                      ? handleOpenDietTypePopup
                      : handleOpenDietPopup
                  }
                />
              )}
              <ByzMuiDataGrid
                columns={columns}
                pageSize={10}
                rows={rows}
                customToolbar={CustomToolbar}
                onRowSelectionModelChange={(newSelection) => {
                  setSelectedMealID(newSelection as number[]);
                }}
                rowSelectionModel={selectedMealIds}
                sx={sharedGridSx}
              />
            </Box>
          </Card>
        ))}
      </div>

      <OpenComponentDialog
        open={open}
        onClose={handleClose}
        isMedCard={false}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: { xs: "100%", sm: "80%", md: "60%", lg: "45%" },
            borderRadius: "8px",
            boxShadow: 3,
          },
        }}
      >
        <MealAdd onClose={handleClose} selectedRow={selectedRows.guide ?? 0} />
      </OpenComponentDialog>
      <OpenComponentDialog
        open={openDietTypePopup}
        onClose={handleCloseDietTypePopup}
        isMedCard={false}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: { xs: "100%", sm: "80%", md: "60%", lg: "45%" },
            borderRadius: "8px",
            boxShadow: 3,
          },
        }}
      >
        <DietTypeAdd
          onClose={handleCloseDietTypePopup}
          selectedRow={selectedRows.guide ?? 0}
        />
      </OpenComponentDialog>
      <OpenComponentDialog
        open={openDietPopup}
        onClose={handleCloseDietPopup}
        isMedCard={false}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: { xs: "100%", sm: "80%", md: "60%", lg: "45%" },
            borderRadius: "8px",
            boxShadow: 3,
          },
        }}
      >
        <DietAdd
          onClose={handleCloseDietPopup}
          selectedRow={selectedRows.guide ?? 0}
          selectedRowPlan={selectedRows.plan ?? 0}
        />
      </OpenComponentDialog>
    </>
  );
}

export default Ration;
